import React from 'react';
import { useNavigate } from 'react-router-dom';
import BondLoanTab from '../components/dashboard/BondLoanTab';
import './StaticPages.css';

export default function BondLoanPage() {
  const navigate = useNavigate();
  return (
    <div className="static-page" data-testid="bond-loan-page"><header className="static-header">
        <div className="container">
          <div className="header-content">
            <img src="/logo.png" alt="House Sharing Seniors" className="logo-image" onClick={() => navigate('/')} />
            <nav>
              <button className="btn btn-secondary" onClick={() => navigate('/properties')}>Browse Properties</button>
              <button className="btn btn-primary" onClick={() => navigate('/apply')}>Apply Now</button>
            </nav>
          </div>
        </div>
      </header>
      <section className="page-hero" style={{ background: '#1a2332', padding: '28px 0' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h1 style={{ color: 'white', marginBottom: 6 }}>Free Government Rental Bond Loan</h1>
          <p style={{ color: 'rgba(255,255,255,0.8)' }}>Every state (except ACT) offers a free, interest-free bond loan — HSS members are pre-qualified</p>
        </div>
      </section>
      <section className="page-content">
        <BondLoanTab currentUser={null} />
      </section>
      <footer className="static-footer">
        <div className="container">
          <p>&copy; 2026 House Sharing Seniors. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
